import { IExternalLogger, LogLevel } from 'src/logging/types';

/**
 * A simple implementation of a logger that prints log messages to the console. This logger
 * implements the {@code IExternalLogger} interface.
 */
export class DefaultLogger implements IExternalLogger {
  /**
   * @method log - logs a message at the specified log level.
   *
   * @param {LogLevel} level - the log level
   * @param {string} message - the log message
   */
  public log(level: LogLevel, message: string): void {
    switch (level) {
      case LogLevel.DEBUG:
        console.debug(message);
        break;
      case LogLevel.INFO:
        console.info(message);
        break;
      case LogLevel.WARNING:
        console.warn(message);
        break;
      case LogLevel.ERROR:
        console.error(message);
        break;
    }
  }
}
